let dirPath = 'static/games/page014_game4';

let configGame = {
  removeInCorrects: true,
  correctBlock: true,
  bruteForce: false,
  //autoCheckAllCorrect: true,
  rulesGame: {
    itemsConfig: { shuffle: true },
    otherProperty: {
      sounds: [{ src: dirPath + '/audio/klik.mp3', id: 'mouseup' }],
    },
    items: [
      {
        idGroup: 'left',
        idItem: 'con1',
        items: [{ idGroup: 'right', idItem: 'con1', correct: [{ idGroup: 'left', idItem: 'con1' }] }],
      },
      {
        idGroup: 'left',
        idItem: 'con2',
        items: [{ idGroup: 'right', idItem: 'con2', correct: [{ idGroup: 'left', idItem: 'con2' }] }],
      },
      {
        idGroup: 'left',
        idItem: 'con3',
        items: [{ idGroup: 'right', idItem: 'con3', correct: [{ idGroup: 'left', idItem: 'con3' }] }],
      },
      {
        idGroup: 'left',
        idItem: 'con4',
        items: [{ idGroup: 'right', idItem: 'con4', correct: [{ idGroup: 'left', idItem: 'con4' }] }],
      },
      {
        idGroup: 'left',
        idItem: 'con5',
        items: [{ idGroup: 'right', idItem: 'con5', correct: [{ idGroup: 'left', idItem: 'con5' }] }],
      },
    ],
  },
  layout: {
    itemsConfig: {
      background: {
        text: {
          lineWidth: 300,
          font: 'Myriad Pro',
          size: '30px',
          textBaseline: 'middle',
          textAlign: 'center',
        },
      },
    },
    otherProperty: {
      lines: {
        good: {
          hideLine: true,
        },
        connect: {
          color: '#000000',
          hideLine: true,
        },
        select: {
          color: '#000000',
          hideLine: true,
        },
      },
      points: {
        pointMouse: {
          color: 'rgba(0,0,0,0.3)',
          rad: 0,
          alwaysShow: true,
        },
        itemsConfig: {
          alwaysShow: true,
          image: {
            src: dirPath + '/img/point.png',
          },
          color: 'transparent',
          positions: { rad: 15 },
        },
      },
      /*    lines: {

            connect: { color: 'black' }
          } */
    },
    groups: [
      {
        idGroup: 'left',
        positions: { autoFit: true, type: 'absolute', pos: { x: 100, y: 0 } },
        itemsConfig: {
          positions: { pos: { width: 114, height: 156 }, margin: { top: 0 }, columns: 1 },
          background: { image: { pos: { y: 21 } } },
        },
        otherProperty: {
          points: {
            itemsConfig: { registrationPoint: { setTo: 'right' } },
            items: [{ id: 'p01', positions: { pos: { setTo: 'right' }, offset: { x: 56 } } }],
          },
        },
        items: [
          { id: 'con1', background: { image: { src: dirPath + '/img/00.png' } } },
          { id: 'con2', background: { image: { src: dirPath + '/img/01.png' } } },
          { id: 'con3', background: { image: { src: dirPath + '/img/02.png' } } },
          { id: 'con4', background: { image: { src: dirPath + '/img/03.png' } } },
          { id: 'con5', background: { image: { src: dirPath + '/img/04.png' } } },
        ],
      },
      {
        idGroup: 'right',
        positions: { autoFit: true, type: 'absolute', pos: { x: 800, y: 0 } },
        itemsConfig: {
          positions: { pos: { width: 908, height: 156 }, margin: { top: 0 }, columns: 1 },
          background: { image: { pos: { x: 56 } } },
        },
        otherProperty: {
          lines: {
            good: {
              hideLine: true,
            },
            connect: {
              color: '#000000',
              hideLine: true,
            },
            select: {
              color: '#000000',
              hideLine: true,
            },
          },
          points: {
            itemsConfig: { registrationPoint: { setTo: 'left' } },
            items: [{ id: 'p01', positions: { pos: { setTo: 'left' }, offset: { x: 21 } } }],
          },
        },
        items: [
          {
            id: 'con1',
            background: { image: { src: dirPath + '/img/10.png' } },
          },
          {
            id: 'con2',
            background: { image: { src: dirPath + '/img/11.png' } },
          },
          {
            id: 'con3',
            background: { image: { src: dirPath + '/img/12.png' } },
          },
          {
            id: 'con4',
            background: { image: { src: dirPath + '/img/13.png' } },
          },
          {
            id: 'con5',
            background: { image: { src: dirPath + '/img/14.png' } },
          },
        ],
      },
    ],
  },
};

let dataConfig = {
  mixinEngine: 'connect',
  realHeight: 800,
  realWidth: 1800,
  mainImage: {
    imagePath: dirPath + '/img/bcg.png',
    pos: {
      y: 0,
      x: 0,
    },
  },
  configGame: configGame,
};

export default dataConfig;
